module.exports = __webpack_public_path__ + "img/home-selling-point1.edec7849.png";